var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert__inner",class:_vm.alertClass},[_c('SvgIcon',{staticClass:"alert__icon",attrs:{"name":_vm.type,"height":"32","width":"32"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }